<template>
  <v-dialog v-model="dialog" max-width="960px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("ShopBillView.Fields.img") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-8 text-center subtitle-1">
        <v-card v-if="album && album.length > 0">
          <v-carousel hide-delimiters cycle>
            <v-carousel-item
              v-for="(item, i) in album"
              :key="i"
              :src="item"
              @click.stop="$showFullscreenImages(album, i)"
            >
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import Settlements from "@/api/settlements";

export default {
  name: "SettlementImagesDialog",

  props: {
    value: Boolean,
    currentItem: Object,
  },

  data: () => ({
    dialog: false,
    album: [],
  }),

  methods: {},
  mounted() {},

  watch: {
    value: {
      immediate: true,
      handler() {
        this.album = [];
        if (this.value && this.currentItem) {
          Settlements.getBillRelatedImg(this.currentItem.bill_id).then(
            function (response) {
              if (response.data.status.isOK()) {
                response.data.img_arr.map((imgArr) => {
                  imgArr.img.forEach((img) => {
                    this.album.push(img)
                  })
                });
              }
              console.log('this.album', this.album)
            }.bind(this)
          )
        } else {
          this.settlement = {};
          this.materialDetails = [];
        }
        this.dialog = this.value
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.album = [];
        }
      },
    },
  },
};
</script>
